<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<mat-card class="content-card">

    <div fxLayout="row" style="">
        <div fxFlex="40">
            <span (click)="returnBack()" style="cursor: pointer; margin-right: 15px;">◀️ Go back</span>

            <button mat-raised-button color="primary" style="margin-right: 10px;" [disabled]="isLoading || !prevNextIds?.prevId" (click)="gotoPrev()">Previous</button>
            <button mat-raised-button color="primary" [disabled]="isLoading || !prevNextIds?.nextId" (click)="gotoNext()">Next</button>


        </div>
        <div fxFlex="40" class="text-center" style="text-align: center;">
            <ng-container *ngIf="session">

            </ng-container>
        </div>






    </div>

</mat-card>



<mat-card class="content-card">
    <div fxLayout="row" style="">
        <div fxFlex="50">
            <h3>MicroPayment Session <ng-container *ngIf="session">{{ session.sessionId}}</ng-container> </h3>
        </div>
        <div fxFlex="50" style="text-align: right;">
            <span *ngIf="customer" style="margin-left: 15px; margin-right: 15px;">
                <a routerLink="/customers-overview/{{ customer.id }}">{{ customer.firstName }} {{ customer.lastName }}</a>
            </span>
            <span *ngIf="company" style="margin-left: 15px; margin-right: 15px;">
                <a routerLink="/companies/{{ company.id }}">{{ company.name }}</a>
            </span>
        </div>
    </div>
</mat-card>

<div fxLayout="row" style="">
    <div fxFlex="40">

        <ng-container *ngIf="session">

                <mat-card class="content-card" *ngIf="session.microPaymentCustomer?.company">
                    <mat-card-header>
                        <mat-card-title>
                            <h5>Company</h5>
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content class="company-card">
                        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCompany">
                            <app-content-row [field]="field" [entity]="session.microPaymentCustomer.company"></app-content-row>
                        </div>
                    </mat-card-content>
                    <mat-card-actions align="end">

                    </mat-card-actions>
                </mat-card>


                <mat-card class="content-card" *ngIf="session.microPaymentCustomer?.customer">
                    <mat-card-header>
                        <mat-card-title>
                            <h5>Customer</h5>
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content class="company-card">
                        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCustomer">
                            <app-content-row [field]="field" [entity]="session.microPaymentCustomer.customer"></app-content-row>
                        </div>
                    </mat-card-content>
                    <mat-card-actions align="end">

                    </mat-card-actions>
                </mat-card>


        </ng-container>

    </div>

    <div fxFlex="60">

        <ng-container *ngIf="session">

                <mat-card class="content-card" *ngIf="session.transactions">
                    <mat-card-header>
                        <mat-card-title>
                            <h5>Transactions</h5>
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content class="company-card">

                            <div style="width: 100%;">
                                <div class="list-item" fxLayout="row" fxLayoutGap="10px" fxFlexFill>
                                    <span class="secondary" fxFlex="10"> Type </span>
                                    <span style="width: 120px;" class="secondary"> Date </span>
                                    <span class="secondary text-right" fxFlex="10"> Amount </span>
                                    <span class="secondary" fxFlex> Iban </span>
                                    <span class="secondary" fxFlex> Name </span>
                                </div>

                                <div id="scroll">
                                    <div *ngFor="let txn of session.transactions.reverse()" class="list-item" fxLayout="row" fxLayoutGap="10px" fxFlexFill>
                                        <span fxFlex="10">
                                            <ng-container *ngIf="txn.type === 1">Created</ng-container>
                                            <ng-container *ngIf="txn.type === 2">Pay-In</ng-container>
                                            <ng-container *ngIf="txn.type === 3">Change</ng-container>
                                            <ng-container *ngIf="txn.type === 4">Refund</ng-container>
                                            <ng-container *ngIf="txn.type === 5">Expire</ng-container>
                                            <ng-container *ngIf="txn.type === 99">Other</ng-container>
                                        </span>
                                        <span style="width: 120px;" >{{txn.createDate| date : "yyyy-MM-dd HH:mm"}}</span>
                                        <span fxFlex="10" class="text-right">
                                            <ng-container *ngIf="txn.type !== 1 && txn.type !== 5">
                                            {{ txn.paidAmount.formatMoney() }} €
                                            </ng-container>
                                        </span>

                                        <span class="table-cell-truncate" fxFlex>{{ txn.iban }}</span>
                                        <span fxFlex>{{ txn.accountHolder }}</span>

                                    </div>
                                </div>
                            </div>


                    </mat-card-content>
                    <mat-card-actions align="end">

                    </mat-card-actions>
                </mat-card>

        </ng-container>

    </div>

</div>

